enum DatasetTag {
  BoardCertifications = 'Board Certifications',
  SanctionsExclusions = 'Sanctions and Exclusions',
  Npi = 'NPI',
  Npdb = 'NPDB',
  Nsc = 'NSC',
  Dea = 'DEA',
  Certificates = 'Certificates',
  MedicaidEnrollment = 'Medicaid Enrollment'
}

export default DatasetTag;
